import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.ODONTOGRAMA.BUSCAR_ODONTOGRAMA](context, dados) {
        const {data} = await api.odontograma.buscarOdontograma(dados)
        return data
    },

}